import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { conversationalWorkflowCacheKeys } from "./constants";
import type { ConversationalWorkflowResult, PutConversationalWorkflowProps } from "./types";

export const putConversationalWorkflow = reactQueryMutationAdapter(
  conversationalWorkflowCacheKeys,
  (props: PutConversationalWorkflowProps): Promise<ConversationalWorkflowResult> => {
    return fetch(
      `/${props.appGroupId}/conversational/workflow/${props.workflowId}`,
      "PUT",
      {
        name: props.name,
        purpose: props.purpose,
        status: props.status,
        expected_status: props.expected_status,
        segment_ids: props.segment_ids,
        steps: props.steps,
        chat_setting: props.chat_setting,
        messaging_channel_setting: props.messaging_channel_setting,
      },
      undefined,
      // Save errors are explained by the form's own toast, not the legacy error modal.
      { propagateFetchRequestError: false }
    );
  }
);
